// @flow
import * as React from 'react'
import Heading from 'ui/atoms/Heading'
import ModalCloseButton from 'ui/atoms/Modal/ModalCloseButton'
import Text from 'ui/atoms/Text'

type Props = {
  title?: string,
  subtitle?: string,
  closeButton?: boolean,
  onHide?: () => void,
}

const ModalHeader = ({
  title,
  subtitle,
  closeButton,
  onHide,
}: Props): React.Node => {
  return (
    <>
      {closeButton && <ModalCloseButton onHide={onHide} />}

      {title && <Heading>{title}</Heading>}
      {subtitle && <Text $light>{subtitle}</Text>}
    </>
  )
}

export default ModalHeader
